import { useDocumentTitle } from '@leagueplatform/web-common';
import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { Masonry } from '@leagueplatform/masonry';
import { StackLayout } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { MASONRY } from 'common/constants';

const SETUP_MARKET_EXPERIENCE_MAX_WIDTH = '500px';

export const SetupMarketExperiencePage = () => {
  usePageViewAnalytics({ screen_name: 'Setup Market Experience' });
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_SETUP_MARKET_EXPERIENCE_TITLE' }));

  return (
    <StackLayout
      orientation="vertical"
      verticalAlignment="center"
      horizontalAlignment="stretch"
      css={{
        marginX: 'auto',
        padding: '$none $two',
        maxWidth: SETUP_MARKET_EXPERIENCE_MAX_WIDTH,
        '@mobile': { padding: '$none $one' },
      }}
    >
      <Masonry rootNodeId={MASONRY.ROOT_NODE_ID_SETUP_MARKET_EXPERIENCE} />
    </StackLayout>
  );
};
